import { useMemo } from 'react'
import { GRUPOS_QUERY } from '../data/grupos'
import { OptionSelect } from '../utils/types'
import { GruposAtivosQuery } from '@/core/types/graphql'
import { useQuery } from '@tanstack/react-query'
import { request } from '../utils/request'

export const useGrupos = () => {
  const { data: { gruposAtivos = [] } = {}, isLoading: loading } = useQuery({
    queryKey: ['gruposAtivos'],
    queryFn: async () => await request<GruposAtivosQuery>(GRUPOS_QUERY)
  })

  const gruposOptions = useMemo(
    () =>
      gruposAtivos?.map(it => ({
        label: it?.nome,
        value: it?.id
      })) as OptionSelect[],
    [gruposAtivos]
  )

  return {
    gruposOptions,
    loading
  }
}
